import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import InReview from "./inreview";
import StaffLayout from "../common/staffLayout";

class InReviewContainer extends React.Component {
    static permission = "Applications.InReview";

    componentDidMount() {
        this.props.loadData();
    }

    getTrProps = (state, rowInfo) => {
        return {
            onClick: (e) => {
                this.rowClick(rowInfo.original);
            },
        }; 
    };

    rowClick = (row) => {
        window.previousLocation = "inreview";
        this.props.history.push(`/applications/application/${row.applicationId}/s/${row.userProfileId}`);
    };

    getSchoolData(schoolName) {
        return this.props.data.filter((d) => d.school === schoolName);
    }

    renderSchools() {
        return this.props.schools.map((school, index) => (
            <InReview school={school.name} data={this.getSchoolData(school.name)} key={index} getTrProps={this.getTrProps} />
        ));
    }

    render() {
        const { showAll } = this.props;
        const totalInReview = this.props.data.length;
        const unassociatedData = this.getSchoolData("");

        return (
            <StaffLayout>
                <h3>Total In Review: {totalInReview}</h3>
                <br />
                {this.renderSchools()}
                {unassociatedData.length > 0 && <InReview school="Unassociated" data={unassociatedData} getTrProps={this.getTrProps} />}
            </StaffLayout>
        );
    }
}

InReviewContainer.propTypes = {
    showAll: PropTypes.bool.isRequired,
    data: PropTypes.array,
    schools: PropTypes.array,
};
const mapStateToProps = (state) => ({
    schools: state.staffMiddleSchools,
});

InReviewContainer = connect(mapStateToProps)(InReviewContainer);
InReviewContainer = withRouter(InReviewContainer);

export default InReviewContainer;
